import { SET_REDIRECT_LOADING } from '../actions';

export const setRedirectLoading = (value) => ({
    type: SET_REDIRECT_LOADING,
    payload: value,
});